import React from "react";
import { useNavigate } from "react-router-dom";

import ParallaxSection from "../components/Parallax/ParallaxSection";
import Hero from "../components/Hero/Hero";
import "./Home.css";

import staffPhoto from "../assets/Binkley_Group_Spring_2026.webp";

function Home() {
  const navigate = useNavigate();

  return (
    <main>
      <div className="home-background">
        <Hero />

        <ParallaxSection
          imageOnLeft={true}
          imageSrc={staffPhoto}
          altText="Binkley Preschool staff smiling in the classroom"
          textContent={
            <div className="about-section">
              <h2>About Binkley</h2>
              <p>
                Nestled in the heart of Chapel Hill, Binkley Preschool is a
                half-day program for curious and growing minds ages two through
                five. Since opening our doors in 1965, our mission has stayed
                as steady as ever:
              </p>
              <p className="highlight">
                Every child in our community deserves a joyful, high-quality
                preschool experience.
              </p>
              <p>
                At Binkley, we know that play isn’t just fun, it’s how children
                learn best! Through laughter, creativity, and exploration, our
                teachers and staff create a loving and nurturing environment
                that will give your little one a strong foundation for their
                exciting educational journey ahead.
              </p>
              <p>
                We’d love to meet you! Reach out with any questions or to
                schedule a tour! We’re always happy to show families what makes
                Binkley so special.
              </p>
              <button
                className="home-btn"
                onClick={() => navigate("/application")}
              >
                Apply now!
              </button>
            </div>
          }
        />

        <div className="quote-section">
          <h2>
            Work hard. <br /> Play Smart. <br /> Play Together.
          </h2>
          <p>- Dean Smith</p>
        </div>
      </div>
    </main>
  );
}

export default Home;
